import { Dataset } from "@tblabs/storage";
import { Order } from "../../Models/Order";
import { PaymentForm } from "../../Models/Payment/PaymentForm";
import { Ticket } from "../../Models/Ticket";
import { BitcoinPriceProvider } from "../../Steps/Payment/Services/BitcoinPriceProvider";
import { TicketToOrderConverter } from "./TicketToOrderConverter";


export class TicketsRepo
{
    constructor(
        private _tickets: Dataset<Ticket>,
        private _ticketToOrderConverter: TicketToOrderConverter,
        private _bitcoinPriceProvider: BitcoinPriceProvider) 
    { }

    public async Open(ticketId: string): Promise<Order | null>
    {
        const ticket = await this._tickets.GetOne(ticketId);

        if (!ticket)
        {
            return null;
        }

        if (ticket.BasketPaymentForm == PaymentForm.Crypto)
        {
            await this._bitcoinPriceProvider.Update();
        }

        const btcValueInPln = this._bitcoinPriceProvider.BtcValueInPln.value ?? (-1);

        const order = this._ticketToOrderConverter.Convert(ticket, btcValueInPln);

        return order;
    }

    public async OpenAll(): Promise<Order[]>
    {
        const tickets = await this._tickets.GetAll();
        
        return tickets.map(ticket => this._ticketToOrderConverter.Convert(ticket, this._bitcoinPriceProvider.BtcValueInPln.value ?? (-1)));
    }

    public async Close(ticketId: string): Promise<void>
    {
        await this._tickets.Delete(ticketId);
    }
}
